// Element UI 插件按需引用
import Vue from 'vue'
import { Cascader, DatePicker, Slider, Badge } from 'element-ui'

// Element 全局配置
Vue.prototype.$ELEMENT = { size: 'mini' }

Vue.use(Cascader)
Vue.use(DatePicker)
Vue.use(Slider)
Vue.use(Badge)
